(ns frontend.exports.exceljs.util
  (:require [clojure.string :as string]
            [oops.core :as oops]))


(def CAPITAL_A 65)

(defn digit->char
  [digit]
  (oops/ocall! js/String "fromCharCode" (+ CAPITAL_A digit)))

(defn char->digi
  [ch]
  (inc (- (oops/ocall! ch "charCodeAt" 0)
          CAPITAL_A)))


(defn col-index->char-str
  [postfix col]
  (let [alpha-digit (- col 1)
        res (str (digit->char (mod alpha-digit 26)) postfix)
        next (oops/ocall! js/Math "floor" (/ alpha-digit 26))]
    (if (pos? next)
      (col-index->char-str res next)
      res)))

(defn cell-address->coords
  [address]
  (let [row-index (js/parseInt (string/replace address #"[A-Z]+" "") 10)
        col-index (-> address
                      (string/replace #"\d+" "")
                      (reverse)
                      (reduce (fn [{:keys [mult result]} ch]
                                {:result (+ result (* mult (char->digi ch)))
                                 :mult   (* mult 26)})
                              {:result 0
                               :mult   1})
                      :result)]
    [row-index, col-index]))
